(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
    constructor() {
    super();
    }

    connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    }

    disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
    });

    observer.observe(this.header);
    }

    onScroll() {
  
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  	
 if (scrollTop == 0) {
     requestAnimationFrame(this.reset.bind(this));
      }
      else{
          requestAnimationFrame(this.reveal.bind(this));
      }

              this.currentScrollTop = scrollTop;
              }

              hide() {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.closeMenuDisclosure();
              
              }

              reveal() {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
              }

              reset() {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
              }

              closeMenuDisclosure() {
              this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
              this.disclosures.forEach(disclosure => disclosure.close());
    }


    }

    customElements.define('sticky-header', StickyHeader);


document.addEventListener("DOMContentLoaded", function () {
  const menuLinks = document.querySelectorAll(".menu-main-link");
  if (window.innerWidth > 991) {
    menuLinks.forEach(link => {
      link.addEventListener("mouseenter", () => {
        const hasSummary = link.querySelector("summary") !== null;

        menuLinks.forEach(l => {
          if (l === link) {
            l.classList.add("active");
            l.classList.remove("non-active");
          } else {
            l.classList.add("non-active");
            l.classList.remove("active");
          }
        });

        if (hasSummary) {
          document.body.classList.add("mega-open");
        }
      });

      link.addEventListener("mouseleave", () => {
        menuLinks.forEach(l => l.classList.remove("non-active", "active"));
        document.body.classList.remove("mega-open");
      });
    });
  }

});

const announcement = document.querySelector('#shopify-section-announcement-bar');
const header = document.querySelector('.header');
const root = document.documentElement;

function updateVisibleHeight(el, variableName) {
  if (!el) return;
  const rect = el.getBoundingClientRect();
  const visibleHeight = Math.max(
    0,
    Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top)
  );
  root.style.setProperty(variableName, `${visibleHeight}px`);
}

function updateHeights() {
  updateVisibleHeight(announcement, '--announcement-height');
  updateVisibleHeight(header, '--header-height');
}

updateHeights();

let ticking = false;
function onScrollOrResize() {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      updateHeights();
      ticking = false;
    });
    ticking = true;
  }
}

window.addEventListener('scroll', onScrollOrResize, { passive: true });
window.addEventListener('resize', onScrollOrResize);

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
setTimeout(function(){
  $('.product-related-slider-wc').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    fade: false,
    arrows: false,
    dots: false,
    slide: 'li',
    focusOnSelect: true,
    infinite: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      }
    }]
  });  
//   var x =  $('.size-variant-list ul').children();

// for (i = 0; i < x.length ; i += 2) {
//   x.slice(i,i+2).wrapAll('<li class="'+ i +'"></li>');
// }
//   $('.size-variant-list ul').slick({
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     fade: false,
//     arrows: false,
//     dots: false,
//     slide: 'li',
//     focusOnSelect: true,
//     infinite: true,
//     responsive: [{
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       }
//     }]
//   });  
  }, 300);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
